"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawDebug = void 0;
const RenderUtil_1 = require("./RenderUtil");
function drawDebug(canvas, renderSpecification) {
    const context = canvas.getContext('2d');
    if (!context) {
        return {
            loaded: false,
            loadPromise: Promise.resolve(),
        };
    }
    (0, RenderUtil_1.drawContents)(context, renderSpecification);
    return {
        loaded: true,
        loadPromise: Promise.resolve(),
    };
}
exports.drawDebug = drawDebug;
